import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const CustomerGroupServiceConfig = {
  name: "CustomerGroup",
  annotations: []
} as ServiceConfig;